/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__, or convert again using --optional-chaining
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const moment = require('moment-timezone');
const Terminal = require('./transport_element_terminal').default;
const Aviation = require('./aviation').default;
const TimeZoneLib = require('../../../lib/time_zone.json');
const { toDomesticTel } = require('../util/string');
const TransportElementAttachFile = require('./transport_element_attach_file').default;

var TransportElement = (function () {
  let camelToSnake = undefined;
  let convertKeysToSnakeCase = undefined;
  TransportElement = class TransportElement {
    static initClass() {
      camelToSnake = str => str.replace(/([A-Z])/g, '_$1').toLowerCase();

      convertKeysToSnakeCase = function (obj) {
        const newObj = {};
        for (var key in obj) {
          var value = obj[key];
          var newKey = camelToSnake(key);
          newObj[newKey] = value;
        }
        return newObj;
      };

      this.prototype.airValidationError =
        '便名を入力してください。\n予約が不要な場合、\n航空券の内容を削除してください。';

      this.prototype.reservationNumberValidationError = '予約番号を入力してください。';

      this.prototype.confirmationNumberValidationError = '確認番号を入力してください。';

      this.prototype.anaSeatNumberValidationError = '国内航空券の場合、座席番号を入力してください。';

      this.prototype.shinkansenValidationError =
        '出発・到着の場所を入力してください。\n予約が不要な場合、\n新幹線の内容を削除してください。';

      this.prototype.expressValidationError =
        '出発・到着の場所を入力してください。\n予約が不要な場合、\n特急の内容を削除してください。';

      this.prototype.railwayticketValidationError =
        '出発・到着の場所を入力してください。\n予約が不要な場合、\n在来線の内容を削除してください。';

      this.prototype.foreignRailwayValidationError =
        '出発・到着の場所を入力してください。\n予約が不要な場合、\n海外鉄道の内容を削除してください。';

      this.prototype.rentalcarValidationError =
        '便名を入力してください。\n予約が不要な場合、\nレンタカーの内容を削除してください。';

      this.prototype.taxiValidationError =
        '便名を入力してください。\n予約が不要な場合、\nタクシーの内容を削除してください。';

      this.prototype.busValidationError =
        '便名を入力してください。\n予約が不要な場合、\nバスの内容を削除してください。';

      this.prototype.timeValidationError = '出発以降を指定してください。';
    }
    constructor(args) {
      let i, keys, option, r;
      if (args == null) {
        args = {};
      }
      args = snakeToCamelObject(args);
      _.assign(this, args);
      this.type = 'transport';
      this.from = new Terminal(args.from);
      this.to = new Terminal(args.to);
      this.peopleNum = args.peopleNum;
      if (!this.transportType) {
        this.transportType = 'domestic_air';
      }
      if (!this.airlineCode) {
        this.airlineCode = '';
      }
      if (!this.airlineName) {
        this.airlineName = '';
      }
      if (!this.airTicketType) {
        this.airTicketType = 0;
      }
      if (!this.cabin) {
        this.cabin = '';
      }
      if (!this.ticketingType) {
        this.ticketingType = 0;
      }
      if (!this.boardingStation) {
        this.boardingStation = '';
      }
      if (!this.arrivalStation) {
        this.arrivalStation = '';
      }
      if (!this.postingNumber) {
        this.postingNumber = '';
      }
      if (!this.exicReceiptNumber) {
        this.exicReceiptNumber = '';
      }
      this.aviations = _.map(args.aviations, a => new Aviation(a));
      this.selectTimeZone = TimeZoneLib;
      this.showFromTimeZoneList = false;
      this.showToTimeZoneList = false;
      this.filteredFromTimeZone = [];
      this.filteredToTimeZone = [];
      this.airReservationNumber = args.airReservationNumber || '';
      this.airConfirmationNumber = args.airConfirmationNumber || '';
      this.airSeatNumber = args.airSeatNumber || '';
      this.airClass = args.airClass || 'M';
      this.evoTicketType = args.evoTicketType;
      this.sakuraTicketType = args.sakuraTicketType;
      this.airSeatType = args.airSeatType;
      this.ticketingExpiredAt = args.ticketingExpiredAt || '';
      this.ticketingAt = args.ticketingAt ? moment(args.ticketingAt) : undefined;
      this.alliesApplicationNumber = args.alliesApplicationNumber;
      this.frontierApplicationNumber = args.frontierApplicationNumber;
      this.skytoursApplicationNumber = args.skytoursApplicationNumber;
      this.name = args.name || '';

      // convert the reservation into array from object
      if (args.transportElementReservations) {
        keys = Object.keys(args.transportElementReservations);
        const transportElementReservations0 = [];
        for (r of Array.from(keys)) {
          transportElementReservations0.push(args.transportElementReservations[r]);
        }
        this.transportElementReservations = transportElementReservations0;
      } else {
        this.transportElementReservations = [];
      }

      // convert the reservation into array from object
      if (args.ticketOprReservations) {
        keys = Object.keys(args.ticketOprReservations);
        const ticketOprReservations0 = [];
        for (r of Array.from(keys)) {
          ticketOprReservations0.push(args.ticketOprReservations[r]);
        }
        this.ticketOprReservations = ticketOprReservations0;
      } else {
        this.ticketOprReservations = [];
      }

      this.reservationNumber = args.reservationNumber || '';
      this.ticketNumber = args.ticketNumber || '';
      // [string, string][]の形で渡してもObjectに変換されてしまうため
      if (this.carProviderOptions) {
        const carProviderArray = [];
        for (i in this.carProviderOptions) {
          option = this.carProviderOptions[i];
          carProviderArray.push([option[0], option[1]]);
        }
        this.carProviderOptions = carProviderArray;
      }
      if (this.carTypeOptions) {
        const carTypeArray = [];
        for (i in this.carTypeOptions) {
          option = this.carTypeOptions[i];
          carTypeArray.push([option[0], option[1]]);
        }
        this.carTypeOptions = carTypeArray;
      }
      this.uploadFileData = null;
      this.transportElementAttachFiles = args.transportElementAttachFiles
        ? Object.values(args.transportElementAttachFiles)
        : [];
      if (this.uploadFileData == null) {
        this.uploadFileData = {};
      }
      for (var file of Array.from(this.transportElementAttachFiles)) {
        var { transportElementId } = file;
        var travelerId = file.travelerInformationId;
        if (travelerId === undefined || transportElementId === undefined) {
          continue;
        }
        if (this.uploadFileData[transportElementId] == null) {
          this.uploadFileData[transportElementId] = {};
        }
        if (this.uploadFileData[transportElementId][travelerId] == null) {
          this.uploadFileData[transportElementId][travelerId] = [];
        }
        this.uploadFileData[transportElementId][travelerId].push(convertKeysToSnakeCase(file));
      }
    }

    handleTransportTypeChange(transportType) {
      this.transportType = transportType;
      return app.render();
    }

    handleAirTicketTypeChange(value) {
      this.airTicketType = parseInt(value);
      return app.render();
    }

    handleCabinChange(value) {
      this.cabin = value;
      return app.render();
    }

    handleTicketingTypeChange(value) {
      this.ticketingType = parseInt(value);
      return app.render();
    }

    handleTicketingTypeChangeWithSuppliedId(value, orderItem, suppliedItems, individualDomesticAirSuppliedItems) {
      this.ticketingType = parseInt(value);
      const { name } = this;
      const { ticketingType } = this;
      orderItem.price.originalPrices = _.map(orderItem.price.originalPrices, function (originalPrice) {
        originalPrice.individualSuppliedItemId(
          name,
          ticketingType,
          suppliedItems,
          individualDomesticAirSuppliedItems
        );
        return originalPrice;
      });
      return app.render();
    }

    handleRailwaySeatTypeChange(value) {
      this.railwaySeatType = parseInt(value);
      return app.render();
    }

    handleRailwayTicketTypeChange(value) {
      this.railwayTicketType = parseInt(value);
      return app.render();
    }

    handleCarProviderChange(value) {
      this.carProvider = value;
      return app.render();
    }

    handleTaxiServiceChange(value) {
      this.taxiService = value;
      return app.render();
    }

    handleNameChange(value) {
      this.name = value;
      return app.render();
    }

    handleBoardingStationChange(value, changeFromName) {
      if (changeFromName == null) {
        changeFromName = false;
      }
      this.boardingStation = value;
      if (changeFromName) {
        this.from.name = value;
      }
      return app.render();
    }

    handleArrivalStationChange(value, changeToName) {
      if (changeToName == null) {
        changeToName = false;
      }
      this.arrivalStation = value;
      if (changeToName) {
        this.to.name = value;
      }
      return app.render();
    }

    handlePeopleNumChange(e) {
      e.preventDefault();
      this.peopleNum = e.target.value;
      return app.render();
    }

    handlePostingNumberChange(value) {
      this.postingNumber = value;
      return app.render();
    }

    handleExicReceiptNumberChange(value) {
      this.exicReceiptNumber = value;
      return app.render();
    }

    toggleFromTimeZoneList() {
      this.showFromTimeZoneList = !this.showFromTimeZoneList;
      if (this.showFromTimeZoneList) {
        this.initialFromTimeZoneList();
      } else {
        this.filteredFromTimeZone = [];
      }
      return app.render();
    }

    toggleToTimeZoneList() {
      this.showToTimeZoneList = !this.showToTimeZoneList;
      if (this.showToTimeZoneList) {
        this.initialToTimeZoneList();
      } else {
        this.filteredToTimeZone = [];
      }
      return app.render();
    }

    handleFromTimeZoneChange(timezone) {
      this.from.changeTimeZone(timezone);
      this.toggleFromTimeZoneList();
      return app.render();
    }

    handleToTimeZoneChange(timezone, toggleTimeZoneList, e) {
      this.to.changeTimeZone(timezone);
      this.toggleToTimeZoneList();
      return app.render();
    }

    handleAirlineCodeChange(value) {
      this.airlineCode = value;
      return app.render();
    }

    handleAirReservationNumberChange(value) {
      this.airReservationNumber = value;
      return app.render();
    }

    handleAirConfirmationNumberChange(value) {
      this.airConfirmationNumber = value;
      return app.render();
    }

    handleAirSeatNumberChange(value) {
      this.airSeatNumber = value;
      return app.render();
    }

    handleAirClassChange(value) {
      this.airClass = value;
      return this.app.render();
    }

    handleCarTypeChange(value) {
      this.carType = value;
      return app.render();
    }

    handleCarTypeOtherChange(value) {
      this.carTypeOther = value;
      return app.render();
    }

    handleLastNameKanaChange(value) {
      this.lastNameKana = value;
      return app.render();
    }

    handleFirstNameKanaChange(value) {
      this.firstNameKana = value;
      return app.render();
    }

    handleDriverTelChange(value) {
      this.driverTel = value;
      return app.render();
    }

    handleRemarksChange(value) {
      this.remarks = value;
      return app.render();
    }

    handleAlliesApplicationNumber(value) {
      this.alliesApplicationNumber = value;
      return app.render();
    }

    handleFrontierApplicationNumber(value) {
      this.frontierApplicationNumber = value;
      return app.render();
    }

    handleSkytoursApplicationNumber(value) {
      this.skytoursApplicationNumber = value;
      return app.render();
    }

    handleReservationNumberChange(value) {
      this.reservationNumber = value;
      return app.render();
    }

    handleTicketNumberChange(value) {
      this.ticketNumber = value;
      return app.render();
    }

    initialFromTimeZoneList() {
      const fromTimezone = this.from.timeZone.split('/')[0];
      const filtered = TimeZoneLib.filter(
        t => t.value.indexOf(fromTimezone) !== -1 || t.value.toLowerCase().indexOf(fromTimezone) !== -1
      );
      return (this.filteredFromTimeZone = filtered);
    }

    initialToTimeZoneList() {
      const toTimezone = this.to.timeZone.split('/')[0];
      const filtered = TimeZoneLib.filter(
        t => t.value.indexOf(toTimezone) !== -1 || t.value.toLowerCase().indexOf(toTimezone) !== -1
      );
      this.filteredToTimeZone = filtered;
      return app.render();
    }

    handleSearchTimeZone(e) {
      let filtered;
      const keyword = e.target.value;
      if (_.isEmpty(keyword)) {
        if (e.target.name === 'fromTimeZone') {
          const fromTimezone = this.from.timeZone.split('/')[0];
          filtered = TimeZoneLib.filter(
            t => t.value.indexOf(fromTimezone) !== -1 || t.value.toLowerCase().indexOf(fromTimezone) !== -1
          );
        } else if (e.target.name === 'toTimeZone') {
          const toTimezone = this.to.timeZone.split('/')[0];
          filtered = TimeZoneLib.filter(
            t => t.value.indexOf(toTimezone) !== -1 || t.value.toLowerCase().indexOf(toTimezone) !== -1
          );
        }
      } else {
        filtered = TimeZoneLib.filter(
          t => t.value.indexOf(keyword) !== -1 || t.value.toLowerCase().indexOf(keyword) !== -1
        );
      }

      if (e.target.name === 'fromTimeZone') {
        this.filteredFromTimeZone = filtered;
      } else {
        this.filteredToTimeZone = filtered;
      }
      return app.render();
    }

    handleTicketTypeChange(value) {
      if (this.isEvoNumbers()) {
        this.evoTicketType = value;
      } else {
        this.sakuraTicketType = value;
      }
      return app.render();
    }

    handleSeatTypeChange(value) {
      this.airSeatType = value;

      return app.render();
    }

    handleTicketingAtChange(date) {
      this.ticketingAt = date;
      return app.render();
    }

    handleUploadFileData(uploadFileData, transportElementId, travelerId) {
      if (this.uploadFileData == null) {
        this.uploadFileData = {};
      }
      if (this.uploadFileData[transportElementId] == null) {
        this.uploadFileData[transportElementId] = {};
      }
      if (this.uploadFileData[transportElementId][travelerId] == null) {
        this.uploadFileData[transportElementId][travelerId] = [];
      }
      this.uploadFileData[transportElementId][travelerId].push(uploadFileData);
      return app.render();
    }

    handleDeleteFile(transportElementId, travelerId, index) {
      if (
        __guard__(
          __guard__(
            this.uploadFileData != null ? this.uploadFileData[transportElementId] : undefined,
            x1 => x1[travelerId]
          ),
          x => x.length
        ) > index
      ) {
        this.uploadFileData[transportElementId][travelerId].splice(index, 1);
        if (this.uploadFileData[transportElementId][travelerId].length === 0) {
          delete this.uploadFileData[transportElementId][travelerId];
        }
        if (Object.keys(this.uploadFileData[transportElementId]).length === 0) {
          delete this.uploadFileData[transportElementId];
        }
        return app.render();
      }
    }

    calcFlightTime() {
      let h, m;
      const fromTime = this.from.time.clone();
      const toTime = this.to.time.clone();
      if (parseInt(fromTime.format('ZZ')) > parseInt(toTime.format('ZZ'))) {
        h = String(Math.floor(toTime.diff(fromTime) / 3600000) + 100).substring(1);
        m = String(Math.floor((toTime.diff(fromTime) - h * 3600000) / 60000) + 100).substring(1);
        return `搭乗時間 : ${h}時間${m}分`;
      } else if (parseInt(fromTime.format('ZZ')) < parseInt(toTime.format('ZZ'))) {
        h = String(Math.floor(toTime.diff(fromTime) / 3600000) + 100).substring(1);
        m = String(Math.floor((toTime.diff(fromTime) - h * 3600000) / 60000) + 100).substring(1);
        return `搭乗時間 : ${h}時間${m}分`;
      } else {
        h = String(Math.floor(toTime.diff(fromTime) / 3600000) + 100).substring(1);
        m = String(Math.floor((toTime.diff(fromTime) - h * 3600000) / 60000) + 100).substring(1);
        return `搭乗時間 : ${h}時間${m}分`;
      }
    }

    startDate() {
      return this.from.time;
    }

    endDate() {
      return this.to.time;
    }

    // FIXME: typo
    ticketingExpiredAtStr() {
      return moment(this.ticketingExpiredAt).format('YYYY月MM月DD日HH時mm分');
    }

    isTicketingExpired() {
      return moment(this.ticketingExpiredAt) < moment();
    }

    rawTicketingExpiredAt(orderItem) {
      if (this.isForeignAir() && (orderItem != null ? orderItem.flight : undefined)) {
        const dates = [];
        if (orderItem.flight.homeword != null ? orderItem.flight.homeword.rawTicketExpiredAt : undefined) {
          dates.push(moment(orderItem.flight.homeword.rawTicketExpiredAt));
        }
        if (orderItem.flight.outword != null ? orderItem.flight.outword.rawTicketExpiredAt : undefined) {
          dates.push(moment(orderItem.flight.outword.rawTicketExpiredAt));
        }
        if (dates.length > 0) {
          return moment.min(dates).format('YYYY年MM月DD日HH時mm分');
        } else {
          return null;
        }
      } else {
        return null;
      }
    }

    isRawTicketingExpired(orderItem) {
      if (!this.isForeignAir()) {
        return false;
      }

      if (!orderItem || !orderItem.flight) {
        return false;
      }

      const dateStr =
        (orderItem.flight.homeword != null ? orderItem.flight.homeword.rawTicketExpiredAt : undefined) ||
        (orderItem.flight.outword != null ? orderItem.flight.outword.rawTicketExpiredAt : undefined);
      if (!dateStr) {
        return false;
      }

      return true;
    }

    title() {
      switch (this.transportType) {
        case 'domestic_air':
          return '国内航空券';
        case 'foreign_air':
          return '海外航空券';
        case 'shinkansen':
          return '新幹線';
        case 'express':
          return '特急';
        case 'railway_ticket':
          return '在来線';
        case 'foreign_railway':
          return '海外鉄道';
        case 'rental_car':
          return 'レンタカー';
        case 'bus':
          return 'バス';
        case 'ana_tabisaku':
          return 'ANA旅作';
        case 'taxi':
          return 'タクシー';
        case 'other':
          return 'その他';
      }
    }

    railwaySeatTypeStr() {
      if (this.isRailway()) {
        switch (this.railwaySeatType) {
          case 0:
            return '自由席';
          case 1:
            return '指定席';
          case 2:
            return 'グリーン車';
          case 3:
            return '回数券';
          case 4:
            return 'EX-IC';
          case 5:
            return 'グランクラス';
          default:
            return '';
        }
      } else {
        return '';
      }
    }

    travelerSeatTypeStr(orderItem, elementIndex = null) {
      if (!this.isRailway()) {
        return '';
      }

      const seatType = this.railwaySeatTypeStr();
      if (!_.isEmpty(seatType)) {
        return seatType;
      }

      if (!orderItem) {
        return '';
      }

      const seatTypes = Array.from(new Set(orderItem.travelerShinkansenSeatTypes(elementIndex)));
      return seatTypes.join('、');
    }

    railwayTicketTypeStr() {
      if (this.isRailway()) {
        switch (this.railwayTicketType) {
          case 0:
            return '通常きっぷ';
          case 1:
            return 'JR九州きっぷ';
          case 2:
            return '回数券';
          case 3:
            return 'EX-IC';
          default:
            return '';
        }
      } else {
        return '';
      }
    }

    travelerTicketTypeStr(orderItem, elementIndex = null) {
      if (!this.isRailway()) {
        return '';
      }

      const ticketType = this.railwayTicketTypeStr();
      if (!_.isEmpty(ticketType)) {
        return ticketType;
      }

      if (!orderItem) {
        return '';
      }

      const ticketTypes = Array.from(new Set(orderItem.travelerShinkansenTicketTypes(elementIndex)));
      return ticketTypes.join('、');
    }

    airTicketTypeStr() {
      if (this.isDomesticAir()) {
        switch (this.airTicketType) {
          case 0:
            return '変更可';
          case 1:
            return '変更不可/特割';
          default:
            return '';
        }
      } else {
        return '';
      }
    }

    airSeatTypeStr() {
      if (this.isDomesticAir()) {
        return this.airSeatType;
      } else {
        return '';
      }
    }

    ticketingTypeStr() {
      if (this.isDomesticAir()) {
        switch (this.ticketingType) {
          case 0:
            return 'AIトラベル';
          case 1:
            return 'アリーズ';
          case 2:
            return 'エボラブルアジア';
          case 5:
            return 'フロンティア';
          case 6:
            return 'スカイツアーズ';
          case 7:
            return 'ANA（代理店）';
          default:
            return '';
        }
      } else {
        return '';
      }
    }

    carTypeStr() {
      if (this.isRentalCar()) {
        switch (this.carType) {
          case 'compact':
            return 'コンパクト';
          case 'sedan':
            return 'セダン';
          default:
            return this.carTypeOther;
        }
      } else {
        return '';
      }
    }

    mappingDescription() {
      const name = this.carTypeStr() || this.name;
      return `${this.title()}：${name}　${this.from.timeStr()}発`;
    }

    isJrPackage(orderItem = null) {
      return orderItem && (orderItem.orderItemType === 10 || orderItem.orderItemCategory === 'jr_package');
    }

    description() {
      return `\
<${this.title()}>
■ご利用：${this.peopleNum}名
■内容
${this.summary()}\
`;
    }

    summary(orderItem = null) {
      let option, s;
      if (this.transportType === 'foreign_air') {
        s = `${this.from.foreignAirDescription()}発 → ${this.to.foreignAirDescription()}着 ${this.name}`;
      } else {
        s = `${this.from.description()}発 → ${this.to.description()}着`;
        if (this.name) {
          s += ` ${this.name.replace(/\n/g, ' ')}`;
        }
      }
      if (
        isAiTravel(this.serviceId) &&
        !this.isEvoNumbers() &&
        this.airReservationNumber &&
        this.airConfirmationNumber
      ) {
        s += `\n予約番号:${this.airReservationNumber}`;
        s += `\n確認番号:${this.airConfirmationNumber}`;
      }
      if (this.evoReservationNumber) {
        s += `\n予約番号:${this.evoReservationNumber}`;
      }
      if (this.evoConfirmationNumber) {
        s += `\n確認番号:${this.evoConfirmationNumber}`;
      }
      if (this.evoApplicationNumber) {
        s += `\n問い合わせ番号:${this.evoApplicationNumber}`;
      }
      if (this.evoSkyPdf) {
        s += `\nSKYPDF:${this.evoSkyPdf}`;
      }
      if (this.carProviderOptions && this.carProvider && this.isRentalCar()) {
        for (option of Array.from(this.carProviderOptions)) {
          if (option[1] === this.carProvider) {
            s += `\n提供元:${option[0]}`;
          }
        }
      }
      if (this.carTypeOptions && this.carType) {
        for (option of Array.from(this.carTypeOptions)) {
          if (option[1] === this.carType) {
            s += `\n車種・クラス:${option[0]}`;
          }
        }
      }
      if (this.carTypeOptions && this.carType === 'other' && this.carTypeOther) {
        s += `:${this.carTypeOther}`;
      }
      if (this.lastNameKana && this.firstNameKana) {
        s += `\n運転者氏名（カナ）:${this.lastNameKana} ${this.firstNameKana}`;
      }
      if (this.driverTel) {
        s += `\n運転者電話番号:${toDomesticTel(this.driverTel)}`;
      }
      if (this.remarks) {
        s += `\n備考:${this.remarks}`;
      }

      if (this.isJrPackage(orderItem) && (orderItem != null ? orderItem.jrAuthCode : undefined)) {
        s += `\nJR認証番号:${orderItem.jrAuthCode}`;
      }
      if (this.isJrPackage(orderItem) && (orderItem != null ? orderItem.jrPickupCode : undefined)) {
        s += `\nJR引取番号:${orderItem.jrPickupCode}`;
      }

      return s;
    }

    detail(orderItem = null, opts) {
      if (opts == null) {
        opts = {};
      }
      const lines = this.structuredDetail(orderItem, opts);
      let s = '';
      for (var line of Array.from(lines)) {
        if (line.label) {
          s += line.label;
        }
        s += line.value;
        s += '\n';
      }
      return s;
    }

    structuredDetail(orderItem = null, opts) {
      if (opts == null) {
        opts = {};
      }
      const lines = [];

      const rawTicketExpiredAt = this.rawTicketingExpiredAt(orderItem);
      if (!_.isEmpty(rawTicketExpiredAt)) {
        lines.push({
          label: '',
          value: `発券期限:${rawTicketExpiredAt}`,
          translate: true
        });
      }

      if (!this.isRailway()) {
        lines.push({
          label: '',
          value: '※表記は現地時刻です。',
          translate: true
        });
      }

      const seatType = this.travelerSeatTypeStr(orderItem, opts.elementIndex);
      if (!_.isEmpty(seatType)) {
        lines.push({
          label: '',
          value: seatType,
          translate: true
        });
      }

      const ticketType = this.travelerTicketTypeStr(orderItem, opts.elementIndex);
      if (!_.isEmpty(ticketType)) {
        lines.push({
          label: '',
          value: ticketType,
          translate: true
        });
      }

      const airTicketType = this.airTicketTypeStr();
      if (!_.isEmpty(airTicketType)) {
        lines.push({
          label: '',
          value: airTicketType,
          translate: true
        });
      }

      const airSeatType = this.airSeatTypeStr();
      if (!_.isEmpty(airSeatType)) {
        lines.push({
          label: '',
          value: airSeatType,
          translate: true
        });
      }

      if (this.isRailway()) {
        lines.push({
          label: '乗車駅:',
          value: this.boardingStation,
          translate: false
        });
        lines.push({
          label: '降車駅:',
          value: this.arrivalStation,
          translate: false
        });
      }

      if (this.isJrPackage(orderItem) && (orderItem != null ? orderItem.jrAuthCode : undefined)) {
        lines.push({
          label: 'JR認証番号:',
          value: orderItem.jrAuthCode,
          translate: false
        });
      }

      if (this.isJrPackage(orderItem) && (orderItem != null ? orderItem.jrPickupCode : undefined)) {
        lines.push({
          label: 'JR引取番号:',
          value: orderItem.jrPickupCode,
          translate: false
        });
      }

      return lines;
    }

    // tabikobo(smk様向け実験用処理)
    tabikoboAviations() {
      return _.sortBy(this.aviations, item => parseInt(item.salesTotal) / item.numberOfParticipants);
    }

    isDomesticAir() {
      return this.transportType === 'domestic_air' || this.transportType === 'ana_tabisaku';
    }

    isForeignAir() {
      return this.transportType === 'foreign_air';
    }

    isShinkansen() {
      return this.transportType === 'shinkansen';
    }

    isExpress() {
      return this.transportType === 'express';
    }

    isSelectBulkTicket() {
      return this.railwayTicketType !== 2;
    }

    isRailwayTicket() {
      return this.transportType === 'railway_ticket';
    }

    isRentalCar() {
      return this.transportType === 'rental_car';
    }

    isBus() {
      return this.transportType === 'bus';
    }

    isTaxi() {
      return this.transportType === 'taxi';
    }

    isForeignRailway() {
      return this.transportType === 'foreign_railway';
    }

    isAir() {
      return this.isDomesticAir() || this.isForeignAir();
    }

    isRailway() {
      return this.isShinkansen() || this.isExpress() || this.isRailwayTicket() || this.isForeignRailway();
    }

    isHotel() {
      return false;
    }

    isChangeable() {
      return this.airTicketType === 0;
    }

    isAirNumbersMissing() {
      return _.isEmpty(this.airReservationNumber) || _.isEmpty(this.airConfirmationNumber);
    }

    // TODO: 実態はstringが返却されるので、booleanを返却するように修正する
    isEvoNumbers() {
      return this.evoReservationNumber || this.evoConfirmationNumber || this.evoApplicationNumber;
    }

    isPackage() {
      return _.includes([2, 3], this.airTicketType);
    }

    ticketType() {
      if (this.isEvoNumbers()) {
        return this.evoTicketType;
      } else {
        return this.sakuraTicketType;
      }
    }

    seatType() {
      return this.airSeatType;
    }

    marketLogType() {
      if (this.transportType === 'foreign_air') {
        return this.type;
      } else {
        return this.transportType;
      }
    }

    validationErrors(orderItemStatus) {
      const errors = [];
      const needStatusGuard = orderItemStatus === 7 || orderItemStatus === 13;

      switch (this.transportType) {
        case 'domestic_air':
          if (this.name === '' || this.name === undefined) {
            errors.push(this.airValidationError);
          }
          if (this.airReservationNumber === '' && needStatusGuard) {
            errors.push(this.reservationNumberValidationError);
          }
          if (this.airConfirmationNumber === '' && needStatusGuard) {
            errors.push(this.confirmationNumberValidationError);
          }
          if (orderItemStatus === 7 && (this.airSeatNumber === '' || this.airSeatNumber === undefined)) {
            errors.push(this.anaSeatNumberValidationError);
          }
          break;
        case 'foreign_air':
          if (this.name === '' || this.name === undefined) {
            errors.push(this.airValidationError);
          }
          if (this.reservationNumber === '' && needStatusGuard) {
            errors.push(this.reservationNumberValidationError);
          }
          break;
        case 'ana_tabisaku':
          if (this.name === '' || this.name === undefined) {
            errors.push(this.airValidationError);
          }
          break;
        case 'shinkansen':
          if (this.boardingStation === '' || this.arrivalStation === '') {
            errors.push(this.shinkansenValidationError);
          }
          if (this.reservationNumber === '' && needStatusGuard) {
            errors.push(this.reservationNumberValidationError);
          }
          break;
        case 'express':
          if (this.boardingStation === '' || this.arrivalStation === '') {
            errors.push(this.expressValidationError);
          }
          if (this.reservationNumber === '' && needStatusGuard) {
            errors.push(this.reservationNumberValidationError);
          }
          break;
        case 'railway_ticket':
          if (this.boardingStation === '' || this.arrivalStation === '') {
            errors.push(this.railwayticketValidationError);
          }
          if (this.reservationNumber === '' && needStatusGuard) {
            errors.push(this.reservationNumberValidationError);
          }
          break;
        case 'foreign_railway':
          if (this.boardingStation === '' || this.arrivalStation === '') {
            errors.push(this.foreignRailwayValidationError);
          }
          if (this.reservationNumber === '' && needStatusGuard) {
            errors.push(this.reservationNumberValidationError);
          }
          break;
        case 'rental_car':
          if (this.name === '' || this.name === undefined) {
            errors.push(this.rentalcarValidationError);
          }
          if (this.reservationNumber === '' && needStatusGuard) {
            errors.push(this.reservationNumberValidationError);
          }
          break;
        case 'taxi':
          if (this.name === '' || this.name === undefined) {
            errors.push(this.taxiValidationError);
          }
          if (this.reservationNumber === '' && needStatusGuard) {
            errors.push(this.reservationNumberValidationError);
          }
          break;
        case 'bus':
          if (this.name === '' || this.name === undefined) {
            errors.push(this.busValidationError);
          }
          if (this.reservationNumber === '' && needStatusGuard) {
            errors.push(this.reservationNumberValidationError);
          }
          break;
      }
      if (this.to.time < this.from.time) {
        errors.push(this.timeValidationError);
      }
      return errors;
    }

    updateParams() {
      return {
        id: this.id,
        type: this.type,
        transport_type: this.transportType,
        air_ticket_type: this.airTicketType,
        ticketing_type: this.ticketingType,
        name: this.name,
        people_num: this.peopleNum,
        railway_seat_type: this.railwayTicketType !== 2 ? this.railwaySeatType : null,
        railway_ticket_type: this.railwayTicketType,
        from: this.from.updateParams(),
        to: this.to.updateParams(),
        boarding_station: this.boardingStation,
        arrival_station: this.arrivalStation,
        posting_number: this.postingNumber,
        exic_receipt_number: this.exicReceiptNumber,
        auto_reservation_status: this.autoReservationStatus,
        sold_out: this.soldOut,
        airline_code: this.airlineCode,
        air_reservation_number: this.airReservationNumber,
        air_confirmation_number: this.airConfirmationNumber,
        air_seat_number: this.airSeatNumber,
        evo_ticket_type: this.evoTicketType,
        evo_application_number: this.evoApplicationNumber,
        evo_reservation_number: this.evoReservationNumber,
        evo_confirmation_number: this.evoConfirmationNumber,
        evo_sky_pdf: this.evoSkyPdf,
        sakura_ticket_type: this.sakuraTicketType,
        air_seat_type: this.airSeatType,
        last_name_kana: this.lastNameKana,
        first_name_kana: this.firstNameKana,
        driver_tel: this.driverTel,
        car_type: this.carType,
        car_type_other: this.carTypeOther,
        remarks: this.remarks,
        car_number: this.carNumber,
        car_provider: this.carProvider,
        taxi_service: this.taxiService,
        ticketing_expired_at: this.ticketingExpiredAt,
        allies_application_number: this.alliesApplicationNumber,
        frontier_application_number: this.frontierApplicationNumber,
        skytours_application_number: this.skytoursApplicationNumber,
        ticketing_at: this.ticketingAt ? this.ticketingAt.tz('Asia/Tokyo').format('YYYY-MM-DD') : undefined,
        reservation_number: this.reservationNumber,
        ticket_number: this.ticketNumber,
        cabin: this.cabin,
        transport_element_attach_file: this.transportElementAttachFile
          ? this.transportElementAttachFile.updateParams()
          : undefined,
        upload_file_data: this.uploadFileData
      };
    }
  };
  TransportElement.initClass();
  return TransportElement;
})();

module.exports = TransportElement;

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}
